import * as fromDatatype from '../datatype-library';


export interface bl_fi_deposit_register_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    category_name: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    prev_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    deposit_date: fromDatatype.TimestampTzDatatypeInterface;
    maturity_date: fromDatatype.TimestampTzDatatypeInterface;
    prev_deposit_date: fromDatatype.TimestampTzDatatypeInterface;
    prev_maturity_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_no: fromDatatype.VarcharDatatypeInterface;
    term_type: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    rollover_options: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    prev_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    prev_server_doc_no: fromDatatype.VarcharDatatypeInterface;
    interest_calc_logic: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    term: fromDatatype.NumericDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    interest_rate: fromDatatype.NumericDatatypeInterface;
    est_interest_amount: fromDatatype.NumericDatatypeInterface;
    actual_interest_amount: fromDatatype.NumericDatatypeInterface;
    blr_plus_interest: fromDatatype.NumericDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_name: fromDatatype.VarcharDatatypeInterface
    deposit_requisition_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_name: fromDatatype.VarcharDatatypeInterface;
    comp_name: fromDatatype.VarcharDatatypeInterface;
    financial_institiution_name: fromDatatype.VarcharDatatypeInterface;
    amount_upon_maturity: fromDatatype.NumericDatatypeInterface;
    interest_earned: fromDatatype.NumericDatatypeInterface;
    interest_type: fromDatatype.VarcharDatatypeInterface;
    interest_calc_period: fromDatatype.VarcharDatatypeInterface;
    interest_rate_effective: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_value: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_delta: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_source: fromDatatype.VarcharDatatypeInterface;
    interest_ref_type: fromDatatype.VarcharDatatypeInterface;
    maturity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    deposit_start_date: fromDatatype.TimestampTzDatatypeInterface;
    inflation_rate: fromDatatype.NumericDatatypeInterface;
    auto_rollover_logic: fromDatatype.VarcharDatatypeInterface;
    gl_code_for_interest: fromDatatype.VarcharDatatypeInterface;
    gl_code_for_interest_expense: fromDatatype.VarcharDatatypeInterface;
    supervisor_remarks: fromDatatype.VarcharDatatypeInterface;
    created_by: fromDatatype.VarcharDatatypeInterface;
    updated_by: fromDatatype.VarcharDatatypeInterface;
    interest_to_principal_logic: fromDatatype.VarcharDatatypeInterface;
    collaterals: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    approval_workflow: fromDatatype.VarcharDatatypeInterface;
    next_deposit_hdr_guid: fromDatatype.GuidDataFieldInterface;
    group_01_guid:fromDatatype.GuidDataFieldInterface;
    auto_rollover_start_date:fromDatatype.TimestampTzDatatypeInterface;
    auto_rollover_end_date :fromDatatype.TimestampTzDatatypeInterface;
    max_rollover_times:fromDatatype.NumericDatatypeInterface;
}


export class bl_fi_deposit_register_hdr_RowClass implements bl_fi_deposit_register_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    category_name: fromDatatype.VarcharDatatypeInterface;
    process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_status_guid: fromDatatype.GuidDataFieldInterface;
    prev_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    deposit_date: fromDatatype.TimestampTzDatatypeInterface;
    maturity_date: fromDatatype.TimestampTzDatatypeInterface;
    prev_deposit_date: fromDatatype.TimestampTzDatatypeInterface;
    prev_maturity_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_no: fromDatatype.VarcharDatatypeInterface;
    term_type: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    rollover_options: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    prev_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    prev_server_doc_no: fromDatatype.VarcharDatatypeInterface;
    interest_calc_logic: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    term: fromDatatype.NumericDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    interest_rate: fromDatatype.NumericDatatypeInterface;
    est_interest_amount: fromDatatype.NumericDatatypeInterface;
    actual_interest_amount: fromDatatype.NumericDatatypeInterface;
    blr_plus_interest: fromDatatype.NumericDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
    deposit_requisition_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_name: fromDatatype.VarcharDatatypeInterface;
    comp_name: fromDatatype.VarcharDatatypeInterface;
    financial_institiution_name: fromDatatype.VarcharDatatypeInterface;
    amount_upon_maturity: fromDatatype.NumericDatatypeInterface;
    interest_earned: fromDatatype.NumericDatatypeInterface;
    interest_type: fromDatatype.VarcharDatatypeInterface;
    interest_calc_period: fromDatatype.VarcharDatatypeInterface;
    interest_rate_effective: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_value: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_delta: fromDatatype.NumericDatatypeInterface;
    interest_rate_ref_source: fromDatatype.VarcharDatatypeInterface;
    interest_ref_type: fromDatatype.VarcharDatatypeInterface;
    maturity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    deposit_start_date: fromDatatype.TimestampTzDatatypeInterface;
    inflation_rate: fromDatatype.NumericDatatypeInterface;
    auto_rollover_logic: fromDatatype.VarcharDatatypeInterface;
    gl_code_for_interest: fromDatatype.VarcharDatatypeInterface;
    gl_code_for_interest_expense: fromDatatype.VarcharDatatypeInterface;
    supervisor_remarks: fromDatatype.VarcharDatatypeInterface;
    created_by: fromDatatype.VarcharDatatypeInterface;
    updated_by: fromDatatype.VarcharDatatypeInterface;
    interest_to_principal_logic: fromDatatype.VarcharDatatypeInterface;
    collaterals: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    approval_workflow: fromDatatype.VarcharDatatypeInterface;
    next_deposit_hdr_guid: fromDatatype.GuidDataFieldInterface;
    group_01_guid:fromDatatype.GuidDataFieldInterface;
    auto_rollover_start_date:fromDatatype.TimestampTzDatatypeInterface;
    auto_rollover_end_date :fromDatatype.TimestampTzDatatypeInterface;
    max_rollover_times:fromDatatype.NumericDatatypeInterface;
}
